<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

  .container-control{
    border: 4px solid #dcdcdc;
    margin: auto;
    height: 120px;
    padding: 15px;
    text-align: center;
    width: 130px;
  }

  .container-alerts{
    width: 130px;
  }

 .alert-float{
    left: -3px;
    position: absolute;
    top:-1px;
  }

  .container-symbology{
    padding: 15px;
    width: 250px;
  }

  .vs-radio--borde{
    border: 2px solid #FFFF!important;
  }

  .device-info>.shadow-drop{
    padding-top: 0.5rem!important;
    padding-bottom: 0.5rem!important;
  }

  .cursor-ponter:hover{
    cursor: pointer;
  }

</style>
<template>
  <div class="item-grid-view vx-row match-height mt-4">
    <div class="vx-col w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">
        <div id="container-map" v-if="status_mapa">
            <l-map style="height: 100%; overflow: hidden;" :zoom="17" :center="center" ref="mymap">
                <l-control position="bottomleft">
                  <div class="relative">
                    <div class="container-symbology bg-white border-2 border-solid border-grey text-center rounded-lg mt-3 centerx">
                      <div class="font-bold">{{$tc('Labels.TankLevel',0)}}</div>
                      <vx-tooltip :text="$t('Labels.Total')" class="inline-block">
                        <div class="text-white rounded-full p-2 w-10 h-10 inline-block m-2 font-bold cursor-ponter hover:bg-primary " :class="{ 'bg-primary': isActiveFilterTotal, 'bg-primary-50': !isActiveFilterTotal }"  @click="filterTankLevel(null,null)">{{levels.total}}</div>
                      </vx-tooltip>
                      <vx-tooltip :text="'50% '+ $t('Labels.To') +' 100%'" class="inline-block">
                        <div class="text-white rounded-full p-2 w-10 h-10 inline-block m-2 font-bold cursor-ponter hover:bg-success" :class="{ 'bg-success': isActiveFilterSuccess, 'bg-success-50': !isActiveFilterSuccess }" @click="filterTankLevel(50,100)">{{levels.success}}</div>
                      </vx-tooltip>
                      <vx-tooltip :text="'20% '+ $t('Labels.To') +' 49%'" class="inline-block">
                        <div class="text-white rounded-full p-2 w-10 h-10 inline-block m-2 font-bold cursor-ponter hover:bg-warning" :class="{ 'bg-warning': isActiveFilterWarning, 'bg-warning-50': !isActiveFilterWarning }" @click="filterTankLevel(19,49)">{{levels.warning}}</div>
                      </vx-tooltip>
                      <vx-tooltip :text="'0% '+ $t('Labels.To') +' 19%'" class="inline-block">
                        <div class="text-white rounded-full p-2 w-10 h-10 inline-block m-2 font-bold cursor-ponter hover:bg-danger" :class="{ 'bg-danger': isActiveFilterDanger, 'bg-danger-50': !isActiveFilterDanger }" @click="filterTankLevel(0,18)">{{levels.danger}}</div>
                      </vx-tooltip>
                    </div>
                  </div>
                </l-control>
                <l-control-layers
                  :position="layersPosition"
                  :collapsed="true"
                  :sort-layers="true"
                />
                <l-control :position="layersPosition">
                  <vs-button @click="showFiltrar = !showFiltrar" class="float-right text-grey-dark border-2 border-solid border-grey py-2 px-3" color="white" type="filled"><iconBase iconName="filter_list" :width="24" :height="24" iconColor="#b8c2cc"><iconFilter/></iconBase></vs-button><!--icon="filter_list"-->
                  <div v-if="showFiltrar" class="bg-white border-2 border-solid border-grey p-4 rounded-lg float-right mr-2">
                    <div class="font-bold mb-2 text-center">{{$t('Labels.Filter') + ' ' +$t('Labels.By')}}:</div>
                    <div class="vx-row mb-6">
                      <vs-checkbox v-model="filterRange" class="ml-4"><span class="font-bold"><span class="capitalize">{{$t('Labels.By')}}</span>{{' ' +$t('Labels.Range')}}</span></vs-checkbox>
                    </div>
                    <div class="vx-row mb-6">
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.From')}}</label>
                        <datepicker :value="filters.begin_date" format="dd-MM-yyyy" :disabled="!filterRange"></datepicker>
                      </div>
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.To')}}</label>
                        <datepicker :value="filters.end_date" format="dd-MM-yyyy" :disabled="!filterRange"></datepicker>
                      </div>
                    </div>
                    <div class="vx-row mb-6">
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.ClientNumber')}}</label>
                        <vs-input class="w-full" v-model="filters.client_number" />
                      </div>
                      <div class="vx-col w-1/2">
                        <label class="font-bold">{{$t('Labels.Serie')}}</label>
                        <vs-input class="w-full" v-model="filters.serie" />
                      </div>
                    </div>
                    <div class="vx-row mb-6">
                      <div class="vx-col w-1/2">
                        <label  class="font-bold">{{$tc('Labels.TankLevel',1)}}</label>
                        <vs-slider v-model="filters.level_tank"/>
                      </div>
                      <div class="vx-col w-1/2">
                        <label  class="font-bold">{{$t('Labels.BatteryLevel')}}</label>
                        <vs-slider v-model="filters.battery"/>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-1/2 "></div>
                      <div class="vx-col w-1/4 text-center">
                        <vs-button @click="getMapa()" color="primary" class="w-full">{{$t('Labels.Filter')}}</vs-button>
                      </div>
                      <div class="vx-col w-1/4 text-center">
                        <vs-button  @click="resetFilters()" color="danger" type="border" class="bg-white w-full">{{$t('Labels.Clean')}}</vs-button>
                      </div>
                    </div>
                  </div>
                </l-control>
                <l-tile-layer
                    v-for="tileProvider in tileProviders"
                    :key="tileProvider.name"
                    :name="tileProvider.name"
                    :visible="tileProvider.visible"
                    :url="tileProvider.url"
                    layer-type="base"
                />

                <v-marker-cluster>
                  <l-marker
                    v-for="marker in markers"
                    :key="marker.alias"
                    :visible="marker.visible"
                    :draggable="marker.draggable"
                    :lat-lng.sync="marker.position"
                  >
                    <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
                      <img v-if="getStatus(marker.percent) == 'success'" :src="require(`@/assets/images/markers/success.svg`)" width="25px;" />
                      <img v-if="getStatus(marker.percent) == 'danger'" :src="require(`@/assets/images/markers/danger.svg`)" width="25px;" />
                      <img v-if="getStatus(marker.percent) == 'warning'" :src="require(`@/assets/images/markers/warning.svg`)" width="25px;" />
                    </l-icon>


                    <l-popup>
                        <div>
                          <div class="container-control rounded-full mt-2 mb-2 relative">
                            <statusItem class="alert-float" :status="marker.updatedAt.length > 0 ? getStatus(marker.percent) : 'grey'"/>
                            <div class="text-xs">{{$t('Labels.Capacity')}}</div>
                            <div class="text-xl font-bold mb-3">{{marker.percent}}%</div>
                            <vs-divider class="my-2 mx-0" border-style="dashed" color="dark"/> 
                            <div class="text-xl font-bold">{{marker.capacity}}L</div>
                            <div class="text-xs">{{$t('Labels.Liters')}}</div>
                          </div>
                          <div class="container-alerts text-center m-auto mb-1">
                            <icon-signal-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="getSignalPercent(marker.rssi)" /> <span class="align-middle">{{getSignalPercent(marker.rssi)}}%</span>
                            <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(marker.battery)" /> <span class="align-middle">{{marker.battery}}%</span>
                          </div>
                          <vx-tooltip :text="marker.updatedAt || $t('Labels.Inactive')" class="text-center">
                            <div class=" text-center text-xs">{{marker.updatedAt.length > 0 ? relativeTimeConvert(marker.updatedAt) : $t('Labels.Inactive')}}</div>
                          </vx-tooltip>
                        </div>
                    </l-popup>

                  </l-marker>
                </v-marker-cluster>
            </l-map>
        </div>

      </vx-card>
    </div>


  </div>
</template>

<script>
import {request} from '@/request.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LLayerGroup,
  LTooltip,
  LIcon,
  LPopup,
  LControl,
  LCircle,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import vSelect from 'vue-select'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import Datepicker from 'vuejs-datepicker'
import iconBase from '@/components/icons/iconBase'
import iconFilter from '@/components/icons/iconFilter'
import iconSignalPercent from '@/components/icons/iconSignalPercent'
import {getSignalPercent, getStatusByPercent, formatDate} from '@/helpers.js'
import iconBatteryPercent from '@/components/icons/iconBatteryPercent'
import statusItem from '@/components/statusItem/statusItem.vue'
import L from 'leaflet'

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]


export default {
  name: 'mapa',
  components: {
    'v-select': vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LControl,
    LCircle,
    LPopup,
    LIcon,
    LControlLayers,
    LLayerGroup,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    Datepicker,
    iconBase,
    iconSignalPercent,
    iconBatteryPercent,
    statusItem,
    iconFilter
  },
  data () {
    return {
      latlngs: [],
      state_values: [
        {label: 'Todos', value: ''},
        {label: 'Conectado', value: 1},
        {label: 'Alerta', value: 0}
      ],
      filters:{
        serie:'',
        client_number: '',
        level_tank: [null, null],
        battery: [null, null],
        begin_date: new Date(),
        end_date: new Date(),
        status: null
      },
      tileProviders,
      layersPosition: 'topright',
      center: [],
      staticAnchor: [12, 27],
      customText: 'Gateway',
      clusterOptions: {},
      imagePath: 'images/vendor/leaflet/dist/',
      response: [],
      markers: [],
      status_mapa: false,
      status_heat: false,
      filterRange: false,
      showFiltrar: false,
      levels:{
        danger: 0,
        warning: 0,
        success: 0,
        total: 0
      },
      isActiveFilterTotal: false,
      isActiveFilterSuccess: false,
      isActiveFilterWarning: false,
      isActiveFilterDanger: false,
      haveFullScreen: false
    }
  },
  methods: {

    async getMapa () {
      this.$vs.loading()
      const filter = {}
      filter.begin_battery = this.filters.battery[0]
      filter.end_battery = this.filters.battery[1]
      if (this.filters.battery[1] !== null && this.filters.battery[0] === null) filter.begin_battery = 0
      filter.begin_percent = this.filters.level_tank[0]
      filter.end_percent = this.filters.level_tank[1]
      if (this.filters.level_tank[1] !== null && this.filters.level_tank[0] === null) filter.begin_percent = 0
      filter.serie = this.filters.serie
      filter.client_number = this.filters.client_number
      
      this.setActivePercent(filter.begin_percent, filter.end_percent)

      if (this.filterRange) {
        filter.begin_date = formatDate(this.filters.begin_date)
        filter.end_date = formatDate(this.filters.end_date)
      }
        
      const params = {
        url: 'gas_devices/map',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.center = [19.25101358132845, -103.69481138016101]
        const positions = []
        this.markers = []
        for (let i = 0; i < this.response.length; i++) {
          if (this.response[i].latlong !== '') {
            positions.push([this.response[i].latlong.split(',')[0], this.response[i].latlong.split(',')[1]])
            this.markers.push({
              position: { lat: this.response[i].latlong.split(',')[0], lng: this.response[i].latlong.split(',')[1] },
              rssi: this.response[i].rssi,
              battery: this.response[i].battery,
              capacity: this.response[i].capacity,
              percent: this.response[i].percent,
              updatedAt:  this.response[i].updatedAt,
              deveui: this.response[i].deveui,
              draggable: false,
              visible: true,
              uuid: this.response[i].uuid
            })
          }
        }


        this.status_mapa = true
        this.$vs.loading.close()
        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          if (!app.haveFullScreen) {
            maps.addControl(new L.Control.Fullscreen())
            app.haveFullScreen = true
          }
          maps.fitBounds(positions)
        }, 1000)
      }).catch(() => {
        this.center = [19.25101358132845, -103.69481138016101]
        this.markers = []
        this.status_mapa = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getCountCapacityLevel () {
      const params = {
        url: 'gas_devices/capacity_levels',
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.levels.total = response.data.data.total
        this.levels.danger = response.data.data['19-0']
        this.levels.warning = response.data.data['49-20']
        this.levels.success = response.data.data['100-50']
      })
    },
    setActivePercent (begin, end) {
      this.isActiveFilterTotal = false
      this.isActiveFilterSuccess = false
      this.isActiveFilterWarning = false
      this.isActiveFilterDanger = false
      const success = process.env.VUE_APP_PERCENT_SUCCESS || 49
      const warning = process.env.VUE_APP_PERCENT_SUCCESS || 19
      if (begin === null && end === null) this.isActiveFilterTotal = true
      else if (parseInt(begin) >= parseInt(success)) this.isActiveFilterSuccess = true
      else if (parseInt(begin) >= parseInt(warning)) this.isActiveFilterWarning = true
      else this.isActiveFilterDanger = true
    },
    resetFilters () {
      this.filters.serie = null
      this.filters.no_client = null
      this.filters.level_tank = [null, null]
      this.filters.battery = [null, null]
      this.filters.begin_date = new Date()
      this.filters.end_date = new Date()
      this.showDate = false
    },
    filterTankLevel (begin, end) {
      this.resetFilters()
      this.filters.level_tank[0] = begin
      this.filters.level_tank[1] = end
      this.markers = []
      this.setActivePercent(begin, end)
      this.getMapa()
    },
    getSignalPercent (value) {
      return getSignalPercent(value)
    },
    getStatus (percent) {
      return getStatusByPercent(percent)
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    }
  },
  sockets: {
    gas (payload) {
      this.markers.forEach(markerToModify => {
        if (markerToModify.deveui === payload.deveui) {
          markerToModify.rssi = payload.rssi
          markerToModify.battery = payload.battery
          markerToModify.percent = payload.percent
          markerToModify.updatedAt = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getMapa()
    this.getCountCapacityLevel()
  }

}
</script>
